import { KeywordOptionE } from '@enums/keyword.enum';
import { FlowTimeoutActionTypeE, FlowTimeoutForwardOptionE } from '@enums/flow-timeout.enum';
import { TypeFlowE } from '@enums/type-flow.enum';
import { TransferT } from '@omnitypes/transfer.type';

export interface FlowI {
  _id?: string;
  name: string;
  description: string;
  customerId: string;
  status: string;
  messageInteraction?: string;
  actions: ActionI[];
  triggers?: FlowTriggerI[];
  simulatorContact?: { name?: string; telephone?: string; email?: string };
  channelType?: string;
  workflowId: string;
  order?: number;
  type?: TypeFlowE;
  context?: string;
  lastUserUpdate?: string;
  timeouts?: FlowTimeoutI[];
  timeSendQueuePosition?: number;
  allowTransferFromAttendance?: boolean;
  keywords?: FlowKeywordI[];
  /** Gravado pelo Mongo; o publish o devolve como base para detectar publicação concorrente. */
  updatedAt?: string;
  isDeleted?: boolean;
}

/**
 * Gatilho proativo da jornada — espelha o modelo do Workflow (WorkflowActionTrigger*).
 * Campos opcionais por tipo; o engine usa triggerType + os campos do tipo correspondente.
 */
export interface FlowTriggerI {
  id: string;
  triggerType: string;
  // TAG
  tagList?: { _id: string; name: string; emoji?: string }[];
  operation?: string;
  // TABULATION
  tabulations?: { _id: string; name?: string }[];
  // API
  payloadSchema?: string;
  contactNameField?: string;
  contactPhoneField?: string;
  contactEmailField?: string;
  // INTEGRATION
  featureTag?: string;
  integrationInstanceId?: string;
  featureName?: string;
  // CHARACTERISTIC
  characteristicList?: { [key: string]: string };
  // EVENT
  event?: string;
}

export interface PartialFlowI {
  _id?: string;
  name?: string;
  description?: string;
  customerId?: string;
  status?: string;
  actions?: ActionI[];
  channelType?: string;
  workflowId?: string;
}

export interface ActionI extends DefaultActionFieldsI {
  body: BodyI | any;
  nextAction?: string | null;
  currentFlow?: string;
}
export interface DefaultActionFieldsI {
  name: ActionsNameT;
  description: string;
  status: StatusE;
  await: boolean;
  lastAction: boolean;
  flowX?: number;
  flowY?: number;
  _id?: string;
  assignTagId?: string;
}

export enum StatusE {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum ActionNameE {
  SEND_MESSAGE = 'send_message',
  TRANSFER = 'transfer',
  CONDITIONAL = 'conditional',
  TRASFER_FLOW = 'transfer_flow',
  TEAMS_VERIFIEL = 'check_team_availability',
  SEND_FILE = 'send_file',
  FINISH_ATTENDANCE = 'finish_attendance',
  RUN_FLOW = 'run_flow',
  SEND_FEEDBACK = 'send_feedback',
  REQUEST_INFO = 'request_info',
  CONDITION = 'conditional',
  INTEGRATION = 'integration',
  AUTHENTICATION = 'authentication',
}

export type ActionsNameT =
  | 'send_message'
  | 'transfer'
  | 'conditional'
  | 'conditional_template'
  | 'transfer_flow'
  | 'check_team_availability'
  | 'check_attendance_hours_team'
  | 'finish_attendance'
  | 'send_file'
  | 'run_flow'
  | 'run_action'
  | 'send_feedback'
  | 'request_info'
  | 'send_protocol'
  | 'integration'
  | 'ai_agent'
  | 'add_horary'
  | 'send_email'
  | 'resume'
  | 'authentication'
  | 'webhook'
  | 'webhook_dynamic_conditional'
  | 'webhook_update_contact'
  | 'conditional_logic'
  | 'block_contact'
  | 'send_form';

export interface BodyI
  extends MessageActionI,
    TransferActionI,
    CondictionActionI,
    TeamsVerifielI,
    SendFileI,
    FinishAttendanceI,
    RunFlowI,
    RequestInfoI {}

export interface MessageActionI {
  message: string;
}

export interface TeamsVerifielI {
  teamId: string;
  subAction?: ActionI;
}

export interface CondictionActionI {
  condition: OperatorE.EQUAL;
  triggers: ConditionalTriggerT[];
  attempts?: number;
}

export interface TransferFlowI {
  _id: string;
}

enum OperatorE {
  EQUAL = 'equal',
}

type ConditionalTriggerT = {
  value: string;
  nextAction: ActionI;
};

export interface TransferActionI {
  customerId: string;
  type?: TransferT;
  to: string;
}

export interface workflowI {
  _id?: string;
  name: string;
  description: string;
  customerId: string;
  flows: FlowI[];
  lastUserUpdate?: string;
}

export interface TransferActionI {
  customerId: string;
  type?: TransferT;
  to: string;
}

export interface SendFileI {
  customerId: string;
  url: string;
}

export interface FinishAttendanceI {
  customerId: string;
}

export interface RunFlowI {
  flow: string;
}

export interface RequestInfoI {
  topic: string;
  message: string;
  field: string;
}

export interface AddConditionalI {
  parentId: string;
  index: number;
}

export interface RemoveConditionalI {
  parentId: string;
  conditionalId: string;
}

export interface UpdateOrderFlowI {
  _id?: string;
  order: number;
}

export enum MessagesInteractionE {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export interface FlowTimeoutI {
  timeout: number;
  timeoutMessage?: string;
  action: {
    type: FlowTimeoutActionTypeE;
    message?: {
      message: string;
      repeat?: number;
    };
    lastAction?: {
      repeat?: number;
    };
    forward?: {
      option: FlowTimeoutForwardOptionE;
      agentTransfer?: {
        agent: {
          _id: string;
        };
      };
      teamTransfer?: {
        team: {
          _id: string;
        };
      };
      runFlow?: {
        flow: {
          _id: string;
        };
      };
    };
  };
  templateId?: string;
}

export interface FlowKeywordI {
  keywords: string[];
  keywordAction: KeywordOptionE;
  keywordForward: string;
}
